export interface BoardMember {
  id: number
  userId: number
  role: string
  photoUrl: string | null
  displayOrder: number
  isVisible: boolean
  user: {
    id: number
    firstName: string
    lastName: string
    profileImage: string | null
  }
}

export const boardMemberImage = (member: BoardMember) => member.photoUrl || member.user.profileImage
